module.exports = __webpack_public_path__ + "img/Businessman-rafiki.738e3dde.svg";